import React, { useEffect, useState } from "react";
import axios from "axios";
import { RotatingLines } from 'react-loader-spinner';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useParams } from 'react-router-dom';

function MultiPayment() {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [staff, setStaff] = useState([]);
    const [staffSelect, setStaffSelect] = useState("");
    const [Customer, setCustomer] = useState([]);
    const [duration, setDuration] = useState({});
    const [valueChange, setValueChange] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [grandTotal, setGrandTotal] = useState(0);
    const user = getCookie('user');
    
    function getCookie(name) {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [key, value] = cookie.split('=');
            if (key === name) { return value; }
        } return null;
    }

    useEffect(() => { if (!user) { navigate('/login') } }, [user, navigate]);

    function durationChange(e) {
        const { name, value } = e.target;
        setDuration(prev => {
            const newDuration = { ...prev, [name]: Number(value) };
            return newDuration;
        });
        
    }
    

    useEffect(() => {
        const newValueChange = {};
        Customer.forEach(user => {
           
                const totalValue = (Number(user.balance_amt) + Number(user.pend_amt)) + 
    ((duration[user.id] && duration[user.id] > 1) ? (duration[user.id] - 1) * user.pay_amt : 0);

            newValueChange[user.id] = totalValue;
        });
        setValueChange(newValueChange);
    }, [Customer, duration]);
    
    useEffect(() => {
        const storedUsers = sessionStorage.getItem("customer");
        if (storedUsers) {
            const parsedUsers = JSON.parse(storedUsers);
            setUsers(parsedUsers);
            sendDataToBackend(parsedUsers);

        }
    }, []);
    async function multiPaymentSubmit() {
        console.log(staffSelect, valueChange, user);
        
        if(!staffSelect || !valueChange || !user ) {
            toast.warning("customer requirement not found !");
            return
        }
        try{
            const response = await axios.post("https://node.cabletvpay.in/multiPaymentSubmit", { staffSelect, valueChange, user, users });
            if (response.status === 200) {
                            toast.success("MultiPayment updated successfully!");
                            setTimeout(() =>{
                                navigate("/allCustomer/all")
                            },1000)
            }
        }catch(error) {
            toast.error(error.response?.data?.message)
            console.log(error);
        }
    }
    const sendDataToBackend = async (customer) => {
        if (!customer || customer.length === 0) {
            toast.error("No users to send!");
            return;
        }

        try {
            const response = await axios.post("https://node.cabletvpay.in/multiPayment", { customer, user });
            setCustomer(response.data.customers);
            setStaff(response.data.staff);
        } 
        catch (error) {
            toast.error("Failed to send data!");
            setError(error.response?.data?.message || "Error fetching data");
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };
 

    useEffect(() => {
        let sum = 0;
        Customer.forEach(user => {
            const totalAmount = (Number(user.balance_amt) + Number(user.pend_amt)) + 
                ((duration[user.id] > 1) ? (duration[user.id] - 1) * user.pay_amt : 0);
            sum += totalAmount;
        });
        setGrandTotal(sum);
    }, [Customer, duration]);

    if (loading) {
        return (
            <div className="content-wrapper">
                <div className="d-flex justify-content-center align-items-center" style={{ height: "80vh" }}>
                    <RotatingLines visible={true} height="80" width="80" strokeColor="#007bff" strokeWidth="2" animationDuration="3" />
                </div>
            </div>
        );
    }
    if (error) {
        return (
            <div className="content-wrapper">
                <div className="d-flex justify-content-center align-items-center" style={{ height: "73vh" }}>
                    <div className="d-flex-column">
                        <img src="../asset/img/errorPage.jpg" alt="Error" style={{ height: "20rem" }} />
                        <div className="text-center">{error}</div>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="content-wrapper">
            <ToastContainer />
            <div className="content-header">
                <div className="d-flex justify-content-between mx-lg-4 mb-3">
                    <h4 className="text-bold p-2 bg-navy shadow" style={{borderRadius:"1rem", border:"4px solid rgb(252, 125, 20)"}}><span className="text-white">{Customer.length} Customer = ₹ {grandTotal}</span>
                    </h4>
                    <div className="mx-2 row">
                        <div className="col-lg-7 col-12 p-1">
                            <select className="form-control bg-navy text-light" name="staff" id="staff" onChange={ (e)=> {setStaffSelect(e.target.value)}} style={{ width: "103%" }}>
                                <option value="">Select a employee</option>
                                {staff.map((i, c) => (
                                    <option key={c} value={`${i.name}|${i.staffCode}|${i.mobile}`}>
                                        {i.name} - {i.staffCode}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-lg-5 col-12 p-1 text-right">
                            <button className="btn btn-success mx-1">Pay</button>
                            <button className="btn btn-danger mx-1" onClick={() =>{ navigate("/allCustomer/all"); }} >Back</button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {Customer.map((user, index) => {
                        const totalValue = (Number(user.balance_amt) + Number(user.pend_amt)) + 
                            ((duration[user.id] > 1) ? (duration[user.id] - 1) * user.pay_amt : 0);

                        return (
                            <div key={index} className="col-lg-3 col-md-6 col-sm-12 col-12">
                                <div className="card">
                                    <div className="card-header bg-gradient-navy pb-1">
                                        <div className="d-flex justify-content-between">
                                            <span className="h5 text-light">
                                                <i className="fas fa-user-circle mx-2" />{user.name}
                                            </span>
                                            <span className="text-yellow h5">{user.acc_num}</span>
                                        </div>
                                    </div>
                                    <div className="card-body p-2">
                                        <table className="table table-bordered table-responsive-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="text-bold">Mobile: <span className="text-orange">{user.mobile}</span></td>
                                                    <td className="text-bold">STB no: <span className="text-orange">{user.serial_num}</span></td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">Package: <span className="text-orange">{user.pay_amt}</span></td>
                                                    <td className="text-bold">Pending: <span className="text-orange">{user.pend_amt || 0}</span></td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">Discount: <span className="text-orange">{user.discount}</span></td>
                                                    <td className="text-bold">CM Amount: <span className="text-orange">{Number(user.balance_amt) + Number(user.pend_amt)}</span></td>
                                                </tr>
                                                <tr>
                                                    <td className="text-bold">
                                                        Plan Duration:
                                                        <span className="text-orange">
                                                            <select name={user.id} id={user.id} className="form-control bg-white border-dark" onChange={durationChange}>
                                                                {[...Array(12)].map((_, i) => (
                                                                    <option key={i + 1} value={i + 1}>{i + 1} month</option>
                                                                ))}
                                                            </select>
                                                        </span>
                                                    </td>
                                                    <td className="text-bold">
                                                        Total: <span className="text-bold h4 text-success">{totalValue}</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div> 
                        );
                    })}
                </div>

                <div className="text-center my-3">
                    <h4 className="text-bold">Grand Total: <span className="text-success">₹ {grandTotal}</span></h4>
                </div>

                <div className="d-flex justify-content-center">
                    <button className="btn btn-success mx-1" onClick={multiPaymentSubmit}>Pay</button>
                    <button className="btn btn-danger mx-1" onClick={() =>{ navigate("/allCustomer/all"); }} >Back</button>
                </div>
            </div>
        </div>
    );
}

export default MultiPayment;